var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuDeleteNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5907 17.953V9.53888C10.5907 9.24142 10.3381 9 10.0269 9C9.71575 9 9.4632 9.24142 9.4632 9.53888V17.953C9.4632 18.2505 9.71575 18.4919 10.0269 18.4919C10.3381 18.4919 10.5907 18.2505 10.5907 17.953ZM14.5368 17.953V9.53888C14.5368 9.24142 14.2842 9 13.9731 9C13.6619 9 13.4093 9.24142 13.4093 9.53888V17.953C13.4093 18.2505 13.6619 18.4919 13.9731 18.4919C14.2842 18.4919 14.5368 18.2505 14.5368 17.953ZM18.7648 7.28318C18.4536 7.28318 18.2011 7.5246 18.2011 7.82206V20.0576C18.2011 20.5232 17.5812 20.9222 17.0736 20.9222H6.70344C6.20454 20.9222 5.79894 20.5345 5.79894 20.0576V7.82206C5.79894 7.5246 5.54638 7.28318 5.2352 7.28318C4.92402 7.28318 4.67147 7.5246 4.67147 7.82206V20.0576C4.67147 21.1286 5.58303 22 6.70344 22H17.0736C18.1379 22 19.3285 21.1693 19.3285 20.0576V7.82206C19.3285 7.5246 19.076 7.28318 18.7648 7.28318ZM20.4363 4.99456H16.228V2.53888C16.228 2.24142 15.9754 2 15.6643 2H8.33573C8.02455 2 7.772 2.24142 7.772 2.53888V4.99456H3.56373C3.25255 4.99456 3 5.23598 3 5.53344C3 5.8309 3.25255 6.07232 3.56373 6.07232H20.4363C20.7474 6.07232 21 5.8309 21 5.53344C21 5.23598 20.7474 4.99456 20.4363 4.99456ZM15.1005 4.99456H8.89947V3.07776H15.1005V4.99456Z",
    fill: "current",
    stroke: "current",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeleteNormal);
export default __webpack_public_path__ + "static/media/menu-delete-normal.042d75cff50f6022343514c9e7b37384.svg";
export { ForwardRef as ReactComponent };